export default "__VITE_ASSET__DQXu9sFL__"